import axios from 'axios'

export default class<T> {
  api: typeof axios

  constructor(api: typeof axios) {
    this.api = api
  }

  all(
    requestPath: string,
    itemsPerPage: number,
    options: Record<string, string> = {}
  ): Promise<T> {
    const requestOptions: Record<string, string> = {
      ...{ itemsPerPage: itemsPerPage.toString(), page: '1' },
      ...options,
    }

    return new Promise((resolve, reject) => {
      this.api
        .get(this.apiCallUrl(requestPath, requestOptions))
        .then((response: Record<string, any>) => {
          let allRecords = response.data['hydra:member']
          const allRecordsCount = response.data['hydra:totalItems']
          const numberOfPages = Math.ceil(allRecordsCount / itemsPerPage)
          const promises = []

          for (let i = 2; i <= numberOfPages; i++) {
            requestOptions.page = i.toString()

            promises.push(
              this.api
                .get(this.apiCallUrl(requestPath, requestOptions))
                .then(
                  (response: Record<string, any>) =>
                    (allRecords = allRecords.concat(
                      response.data['hydra:member']
                    ))
                )
                .catch((error) => reject(error))
            )
          }

          Promise.all(promises)
            .then(() => resolve(allRecords))
            .catch((error) => reject(error))
        })
        .catch((error) => reject(error))
    })
  }

  concatParams(options: Record<string, string>) {
    const result = []
    for (const key in options) {
      result.push(key + '=' + options[key])
    }
    return result.join('&')
  }

  apiCallUrl(requestPath: string, options: Record<string, string>) {
    return requestPath + '?' + this.concatParams(options)
  }
}
